import * as React from 'react';

/**
 * Хук, возвращающий высоту виртуальной клавиатуры для мобильных устройств
 * Нужно, чтобы избежать перекрытие элементов страницы клавиатурой
 */
export function useSoftwareKeyboardHeight() {
  // При первом рендере не обращаемся к window для корректной работы на node
  const [viewportHeight, setViewportHeight] = React.useState<number>(0);
  const [innerHeight, setInnerHeight] = React.useState<number>(0);
  const keyboardHeight = React.useMemo(
    () => (viewportHeight && innerHeight ? innerHeight - viewportHeight : 0), // обычная высота минус высота без клавиатуры
    [viewportHeight, innerHeight],
  );

  // Следим за событием resize и получаем высоту экрана за вычетом высоты клавиатуры
  React.useEffect(() => {
    if (!window.visualViewport) {
      return;
    }

    const handleResize = () => {
      const newHeight = window.visualViewport?.height || 0;

      // visualViewport.height - высота экрана за вычетом высоты клавиатуры
      setViewportHeight(newHeight);
      setInnerHeight(window.innerHeight);
    };

    window.visualViewport?.addEventListener('resize', handleResize);

    handleResize();

    return () => {
      window.visualViewport?.removeEventListener('resize', handleResize);
    };
  }, []);

  return keyboardHeight;
}
